import { render, staticRenderFns } from "./TkBanner.vue?vue&type=template&id=52294864&scoped=true&"
import script from "./TkBanner.vue?vue&type=script&lang=js&"
export * from "./TkBanner.vue?vue&type=script&lang=js&"
import style0 from "./TkBanner.vue?vue&type=style&index=0&id=52294864&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52294864",
  null
  
)

export default component.exports